class FormTextArea extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const $closeIcon = <HTMLElement>this.querySelector(".form-textarea .close");
        $closeIcon?.addEventListener("click", this.clearInputValue.bind(this));
    }

    clearInputValue() {
        const targetEle = this.querySelector('textarea');
        if(targetEle) {
            targetEle.value = "";
        }
    }
}

customElements.define("form-textarea", FormTextArea);
